var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.63 7.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#ffffff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "video") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ALL_-_ICONS",
    "data-name": "ALL - ICONS"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.28.35V6.9H.34V.35H8.28M8.63,0H0V7.25H8.63V0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.34,
    y: 1.38,
    width: 1.38,
    height: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.34,
    y: 2.76,
    width: 1.38,
    height: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.34,
    y: 4.14,
    width: 1.38,
    height: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.73,
    y: 3.45,
    width: 5.18,
    height: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.38,
    y: 0.35,
    width: 0.35,
    height: 6.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.9,
    y: 0.35,
    width: 0.35,
    height: 6.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.34,
    y: 5.52,
    width: 1.38,
    height: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.9,
    y: 1.38,
    width: 1.38,
    height: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.9,
    y: 2.76,
    width: 1.38,
    height: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.9,
    y: 4.14,
    width: 1.38,
    height: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.9,
    y: 5.52,
    width: 1.38,
    height: 0.34
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.2088561563ed9d1d92b08dee43a99a68.svg";
export { ForwardRef as ReactComponent };